import { IndustryConfig } from '../../../types'

export const foodServiceFranchiseConfig: IndustryConfig = {
  id: 'food-service-franchise',
  name: 'Food Service & Franchise Operations',
  icon: '🍕',
  description: 'Food service establishments and franchise operations focused on operations and growth planning',
  
  businessTypes: [
    {
      id: 'restaurant-operation',
      name: 'Restaurant Operation',
      description: 'Full-service restaurants, cafes, and dining establishments'
    },
    {
      id: 'quick-service',
      name: 'Quick Service Restaurant',
      description: 'Fast food, quick casual, and counter service establishments'
    },
    {
      id: 'franchise-operation',
      name: 'Franchise Operation',
      description: 'Franchised food service locations and multi-unit operations'
    },
    {
      id: 'catering-service',
      name: 'Catering & Event Services',
      description: 'Catering companies and event-based food service providers'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'dine-in-sales',
      name: 'Dine-in Sales',
      description: 'Revenue from in-restaurant dining and table service',
      intelligenceValue: "We'll monitor dining trends, table turn rates, and local competition to help you optimize your dine-in experience, pricing, and seating capacity utilization."
    },
    {
      id: 'takeout-delivery',
      name: 'Takeout & Delivery',
      description: 'Revenue from takeout orders and delivery services',
      intelligenceValue: "We'll track delivery platform trends, commission rates, and ordering patterns to help you optimize your off-premise sales and delivery partnerships."
    },
    {
      id: 'catering-events',
      name: 'Catering & Events',
      description: 'Revenue from catering services and special events',
      intelligenceValue: "We'll monitor event catering demand, seasonal patterns, and competitive pricing to help you expand your catering business and optimize event service offerings."
    },
    {
      id: 'retail-merchandise',
      name: 'Retail & Merchandise',
      description: 'Revenue from packaged goods, merchandise, and branded products',
      intelligenceValue: "We'll track retail food trends, margin opportunities, and customer purchasing patterns to help you identify profitable retail extensions and merchandise opportunities."
    }
  ],
  
  supplierCategories: [
    {
      id: 'food-beverage',
      name: 'Food & Beverage',
      suppliers: ['Food distributors', 'Beverage suppliers', 'Local suppliers', 'Specialty ingredient providers', 'Organic/sustainable suppliers'],
      spendRanges: ['Under $10K', '$10K-$50K', '$50K-$200K', 'Over $200K']
    },
    {
      id: 'equipment-supplies',
      name: 'Equipment & Supplies',
      suppliers: ['Kitchen equipment', 'Dining supplies', 'Packaging materials', 'Cleaning supplies', 'Maintenance services'],
      spendRanges: ['Under $5K', '$5K-$25K', '$25K-$100K', 'Over $100K']
    },
    {
      id: 'operations-services',
      name: 'Operations & Services',
      suppliers: ['POS systems', 'Delivery platforms', 'Waste management', 'Pest control', 'Accounting services'],
      spendRanges: ['Under $3K', '$3K-$12K', '$12K-$40K', 'Over $40K']
    },
    {
      id: 'facility-overhead',
      name: 'Facility & Overhead',
      suppliers: ['Rent/lease', 'Utilities', 'Insurance', 'Marketing/advertising', 'Staff wages'],
      spendRanges: ['Under $15K', '$15K-$60K', '$60K-$250K', 'Over $250K']
    }
  ],
  
  competitiveFactors: [
    'Food quality consistency',
    'Service speed',
    'Price competitiveness',
    'Location convenience',
    'Menu variety',
    'Atmosphere/ambiance',
    'Customer service',
    'Cleanliness standards',
    'Brand recognition',
    'Online presence'
  ]
}